import EdPresentationModeMixin from '@/content/mixins/ed-presentation-mode.mixin';
import { SEND_CURRENT_SHARED_TASK_EVENT, CLEAN_CURRENT_SHARED_TASK_EVENT } from '@/content/values/ed-presentation-mode.values';
import { COURSE_EVENTS } from '@/content/values/events';
import Component from 'vue-class-component';
import { TranslateResult } from 'vue-i18n';
import { Mixins, Prop } from 'vue-property-decorator';
import { MEETINGS_STORE } from '@/meetings/store/meetings.store';

@Component({})
export default class EdPresentationModeShareToggle extends Mixins(EdPresentationModeMixin) {

  @Prop()
  public sectionId : number;

  @Prop()
  public courseId : number;

  public switchToggle : boolean = false;
  private isSectionLoaded : boolean = false;
  private sharedData : any = {}

  get switchToggleTitle() : TranslateResult {
    return this.$t('meetings.presentationMode.share');
  }

  get isDisable() : boolean {
    // return this.currentPresentationSection.sectionId !== this.sectionId || !this.isWhiteboardTransparency;
    return this.sectionForCourse(this.courseId)?.sectionId !== this.sectionId || !this.isWhiteboardTransparency;
  }

  get selectedBoardInfo() : {[key: string]: any} {
    return this.$store.state.HomeworksStore.selectedBoardInfo;
  }

  public changeValues(emitEvent : boolean = true) : void {
    if(this.isDisable){
      this.switchToggle = false;
      this.isSectionLoaded = false;
      this.sharedData = {};
      return;
    }

    if(!this.isSectionLoaded){
      this.isSectionLoaded = true;
      this.switchToggle = true;
    }
    let data : any = this.buildDataToShare();

    if(this.sharedData.active === data.active && this.sharedData.userId === data.userId){
      return;
    }

    this.sharedData = { ...data };

    if(!data.isTeacher){
      data.boardGroupHash = this.selectedBoardInfo.boardGroupHash;
      data.numberPages = this.selectedBoardInfo.numberPages;
      data.homeworkId = this.selectedBoardInfo.homeworkId;
    }
    this.$store.commit(MEETINGS_STORE.MUTATIONS.SET_SHARE_TASK_DATA, data);
    if(emitEvent){
      this.$edEventBus.$emit(COURSE_EVENTS.SEND_SHARE_TASK, data);
    }
  }

  public onChangeShare() : void {
    this.changeValues(true);
  }

  private buildDataToShare() : any {
    let data : any = {
      active: this.switchToggle
    };

    if(this.currentBoardUser.id){
      data.userId    = this.currentBoardUser.id;
      data.fullName  = this.currentBoardUser.fullName;
      data.isTeacher = this.currentBoardUser.id === this.userLoginId;
    } else {
      data.userId    = this.user.id,
      data.fullName  = this.$t('myContent.teacher'),
      data.isTeacher = true
    }
    return data;
  }

  private cleanSharedData(): void {
    this.sharedData = {};
  }

  mounted() {
    this.$edEventBus.$on(SEND_CURRENT_SHARED_TASK_EVENT, this.changeValues);
    this.$edEventBus.$on(CLEAN_CURRENT_SHARED_TASK_EVENT, this.cleanSharedData);
  }

  beforeDestroy() {
    this.$edEventBus.$off(SEND_CURRENT_SHARED_TASK_EVENT, this.changeValues);
    this.$edEventBus.$off(CLEAN_CURRENT_SHARED_TASK_EVENT, this.cleanSharedData);
  }

}